module.exports = __webpack_public_path__ + "media/img/favicon-96x96-1599bb85f7ae9088386d5b9e849d7349.png";